(function($){
  var STEP_RX = /schritt\s+(\d+)\s*(?:von|\/)\s*(\d+)/i;

  function parseSteps(txt){
    var m = (txt||'').match(STEP_RX);
    if(!m) return null;
    var cur = +m[1], total = +m[2];
    if(!total || cur<0 || cur>total) return null;
    return { cur, total, frac: Math.min(1, Math.max(0, cur/total)) };
  }

  function ensureBar($h){
    var $wrap = $h.closest('.headline-wrapper');
    var $bar = $wrap.children('.wizard-progress');
    if ($bar.length) return $bar;
    $bar = $('<div class="wizard-progress" role="progressbar" aria-valuemin="0" aria-valuemax="100"><div class="wizard-progress__fill"></div></div>');
    $wrap.append($bar);
    return $bar;
  }

  function update($h){
    var s = parseSteps($.trim($h.text()));
    var $bar = ensureBar($h);
    if(!s){ $bar.hide(); return; }
    $bar.show()
      .attr({'aria-valuenow': Math.round(s.frac*100), 'aria-label': 'Fortschritt '+s.cur+' von '+s.total})
      .find('.wizard-progress__fill').css('transform','scaleX('+s.frac+')');
  }

  function initOnce($root){
    $root.find('.Form_FormGenerator .headline-wrapper .headline3').each(function(){ update($(this)); });
  }

  // Bei DOM ready UND (optional) nach allen Ressourcen
  $(initOnce.bind(null, $(document)));
  $(window).on('load', function(){ initOnce($(document)); });
})(jQuery);